export const zIndex = {
  circle: 1,
  cluster: 98,
  control: 99,
  dot: 2,
  map: 0,
  marker: 3,
};
